import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const getAADApplicationReport = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.REPORT.ACCESS_REPORT.GET_AAD_APPLICATION_ACCESS_REPORT,
    data
  );
};

export default getAADApplicationReport;
